import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/metaverse-new/why_choose_meta.webp";

const Androidbuss = () => {
  return (
    <div
      className="androidbuss p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={8}
            lg={8}
            xl={9}
            xxl={9}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#fff" }}>
              Why Choose TekRevol as Your Metaverse Development Company
            </h2>
            <p style={{ color: "#fff" }}>
              A website is your business’s digital storefront for direct online
              user interactions. An appealing and optimized website helps
              focalize marketing efforts, accelerate growth, and outperform the
              competition. Our experienced website development company anchors
              you there with excellence.
            </p>
          </Col>
        </Row>
        <Row className="h-100 buss-padd">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Advanced Spatial Computing</h6>
                <p>
                  Realistic virtual environments with seamless navigation via
                  cutting-edge spatial computing.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Robust Blockchain Integration</h6>
                <p>
                  Secure, decentralized metaverse apps with enhanced data
                  integrity and privacy.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Real-Time Data Processing</h6>
                <p>
                  Responsive virtual experiences ensure smooth performance and
                  user engagement.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>Cross-Platform Compatibility</h6>
                <p>
                  Dynamic, consistent metaverse experience across VR, AR, and
                  mobile platforms.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>AI-Driven Personalization</h6>
                <p>
                  Personalised user experiences with AI and machine learning
                  adapting to user preferences.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="androidbuss_box">
              <div className="andoidbuss_content">
                <h6>High-Performance Rendering</h6>
                <p>
                  High-fidelity graphics and smooth animations with GPU
                  acceleration for visual realism.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Androidbuss;
